import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportComponent } from './components/report/report.component';



@NgModule({
  declarations: [
    ReportComponent
  ],
  imports: [
    CommonModule
  ]
})
export class ReportModule { }
